export default "__VITE_ASSET__DXA8q6v9__"